import maDamagedItemBtn from '@/components/buttons'
import maNavbarCategory from '@/components/navbarCategories'
import updateDamagesBtn from '@/components/button-blue'
import maForm from '@/components/form'
import maInputSurface from '@/components/input/modules/text'
import { required, minValue } from 'vuelidate/lib/validators'
import { ASSETS, LEVEL_1, AUTRES_GEN, AUTRES_VALUE, EXT, GLASS_SURFACE_LEN, GLASS_SURFACE_WID } from '@/constants'
import maEventBus from '@/components/eventbus/index.js'
import debounce from '@/utils/debounce'
import { apiPatchDamage } from '@/modules/Damage/services/damages'
import { mapState, mapMutations, mapActions } from 'vuex'
import { apiGetForm } from '@/modules/Damage/services/menus'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_UPDATE_REPORT,
  WARRANTY_GET_FORMS,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_CLEAR_REPORT,
  WARRANTY_UPDATE_REPORTS_MURS,
  WARRANTY_UPDATE_REPORTS_PROPERTIES,
  WARRANTY_UPDATE_REPORTS_BY_CATEGORY,
  WARRANTY_CLEAR_REPORT_BY_CATEGORY,
  WARRANTY_CLEAR_REPORT_MURS,
  WARRANTY_ADD_REPORTS,
  WARRANTY_GET_SINISTER_WOLOADER,
  WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS,
  WARRANTY_UPDATE_REPORTS_SURFACE,
  WARRANTY_UPDATE_LAST_SELECTED_KEY,
  WARRANTY_UPDATE_LAST_SELECTED_VALUE,
  WARRANTY_UPDATE_DAMAGED_PART_KEY
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import * as Sentry from '@sentry/vue'
import form from '../../../../components/form/form'

export default {
  name: 'damagesDetails',

  mixins: [flowMixin],

  data: function () {
    return {
      /**
       *  @property {Array} dataForms Array retrieved from the apiGetForms service which contains the info of all the damage types.
       *  @property {Boolean} activeInput It is used to set the input focus when the form is updated
       *  @property {Boolean} activeInputValue It is used to set the input focus when the form is updated
       *  @property {Boolean} inputSurfaceData Data of the input surface when the assets are bienes imobilieres
       *  @property {Boolean} showInputSurface If the category is bienes imobilieres, value is true
       *  @property {Boolean} targetCategory Category of the form that is being modified
       *  @property {Boolean} formKey Category of the form that is being modified
       *  @property {Boolean} inputSurfaceValue Input surface value that is the same with the inputSelectedValue
       */
      dataForms: [],
      activeInput: '',
      activeInputValue: '',
      inputSurfaceData: null,
      inputDescriptionData: null,
      inputDescriptionData: null,
      showInputSurface: false,
      damageSurface: null,
      targetCategory: '',
      formKey: 0,
      inputSurfaceValue: 0,
      imageCategoriesEnsemble: [],
      imageCategoriesPres: [],
      inputTextNumberError: false,
      titleError: '',
      reportsQty: null,
      formsDamages: [],
      imgList: [],
      formRegions: [],
      inputTextNrFormError: false,
      inputTextDescriptionFormError: false,
      inputTextDescriptionFormError: false,
      timer: 0,
      errorDamage: false,
      loading: false,
      spinner: false,
      avoidUpdateFormFields: [AUTRES_GEN, AUTRES_VALUE, GLASS_SURFACE_LEN, GLASS_SURFACE_WID]
    }
  },
  validations: {
    inputSurfaceValue: {
      required,
      minValue: minValue(1)
    },
    inputDescriptionData: {
      required
    }
  },
  components: {
    maDamagedItemBtn,
    maNavbarCategory,
    updateDamagesBtn,
    maForm,
    maInputSurface
  },
  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyReport: 'report',
      stateWarrantyForms: 'forms',
      stateWarrantySecondaryId: 'secondaryId',
      stateWarrantyAddress: 'address',
      stateWarrantyZipCode: 'zipCode',
      stateWarrantyCoordinates: 'coordinates',
      stateWarrantyMoreThanTwoYears: 'moreThanTwoYears',
      stateWarrantyResidentType: 'residentType',
      stateWarrantyDamagedItem: 'damagedItem',
      stateWarrantySelectedDamagedParts: 'selectedDamagedParts',
      stateWarrantyCounterMurs: 'counterMurs',
      stateWarrantyDamagedPartKey: 'damagedPartKey',
      stateWarrantyDamagedItemKey: 'damagedItemKey',
      stateWarrantyLastSelctedKey: 'lastSelectedKey',
      stateWarrantyCategoryId: 'categoryId',
      stateWarrantySubtypeId: 'subtypeId',
      stateWarrantyDamageTypeLiteral: 'damageTypeLiteral'
    }),
    getBtnType() {
      return this.loading ? 'spinnerBtn' : 'functionalBtn'
    },

    /**
     * Based on the route category processes and returns the title
     */
    titleCategory() {
      const category = this.getDamagedItem
      const title = category.replace('_', ' ').replace('_', ' ').toLowerCase()
      return title
    },

    /**
     * Sets the damageType title based on the stateWarrantyDamageTypeLiteral if exists, else it gets it from the local storage
     */
    titleNavBar() {
      const titleLocalStorage = localStorage.getItem('damageTypeLiteral')
      return this.stateWarrantyDamageTypeLiteral
        ? this.stateWarrantyDamageTypeLiteral
        : titleLocalStorage
    },

    /**
     * Returns the damagedItemKey from the state if exists or from the local storage
     */
    getDamagedItemKey() {
      const damagedItemLocalStorage = localStorage.getItem('damagedItemKey')
      return this.stateWarrantyDamagedItemKey
        ? this.stateWarrantyDamagedItemKey
        : damagedItemLocalStorage
    },

    /**
     * If the damaged Item has level two, in the route it will be listed the name of the second level, otherwise it will be just level2, if it doesen't have level2 in the route it means it has a level 2
     */
    damagedItemHasLevel2() {
      return this.stateWarrantyDamagedItemKey !== LEVEL_1
    }
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyUpdateReport: WARRANTY_UPDATE_REPORT,
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS,
      mutWarrantyClearReport: WARRANTY_CLEAR_REPORT,
      mutWarrantyUpdateReportMurs: WARRANTY_UPDATE_REPORTS_MURS,
      mutWarrantyClearReportMurs: WARRANTY_CLEAR_REPORT_MURS,
      mutWarrantyUpdateReportProperties: WARRANTY_UPDATE_REPORTS_PROPERTIES,
      mutWarrantyUpdateReportByCategory: WARRANTY_UPDATE_REPORTS_BY_CATEGORY,
      mutWarrantyClearReportByCategory: WARRANTY_CLEAR_REPORT_BY_CATEGORY,
      mutWarrantyAddReport: WARRANTY_ADD_REPORTS,
      mutWarrantyClearSelectedDamagedParts:
        WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS,
      mutWarrantyUpdateReportSurface: WARRANTY_UPDATE_REPORTS_SURFACE,
      mutWarrantyUpdateLastSelectedKey: WARRANTY_UPDATE_LAST_SELECTED_KEY,
      mutWarrantyUpdateLastSelectedValue: WARRANTY_UPDATE_LAST_SELECTED_VALUE,
      mutWarrantyUpdateDamagedPartKey: WARRANTY_UPDATE_DAMAGED_PART_KEY
    }),
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetForms: WARRANTY_GET_FORMS,
      actWarrantyGetSinisterWoLoader: WARRANTY_GET_SINISTER_WOLOADER
    }),

    /**
     * Updates the state report, calls action actWarrantyGetForms to get the froms and sets the data for the forms, sets the default value inputs for the form
     */
    getForm() {
      this.imageCategoriesEnsemble = []
      this.imageCategoriesPres = []
      this.mutWarrantyClearForms()
      this.mutWarrantyClearReportMurs()
      this.stateWarrantyReport.forEach((reportWarranty) => {
        const warrantyId = this.getWarrantyId
        const report = reportWarranty
        this.actWarrantyGetForms({ report, warrantyId }).then((resp) => {
          if (resp.formsUpdated) {
            if (
              this.stateWarrantyForms.length ===
              this.stateWarrantySelectedDamagedParts.length
            ) {
              this.setFormsData()
              this.setSelectedValueInputs()
              this.setImageCategories()
              this.formRegions = []
            }
          }
        })
      })
    },

    /**
     * For each report object in the report state, it adds the asset damages, and creates the reports in order to post the damages
     */
    handleSetFormDamage: async function () {
      this.formsDamages = []
      // add asset damages
      this.addAssetDamages()

      // update surface value
      if (this.inputSurfaceData) this.addSurfaceInfoToReport()

      // update the reports quatity
      this.reportsQty = parseInt(this.stateWarrantyReport.length)
      await this.stateWarrantyReport.forEach((report) => {
        if (report.OLD_PROPERTY_AGE) {
          delete report.OLD_PROPERTY_AGE
        }
        this.imgList = []
        // concat image lists
        if (this.damagedItemHasLevel2) {
          this.setImageLists(this.stateWarrantyDamagedPartKey || this.targetCategory, report)
        } else {
          this.setImageLists(this.stateWarrantyLastSelctedKey, report)
        }

        const subTypeId = this.stateWarrantySubtypeId
          ? this.stateWarrantySubtypeId
          : localStorage.getItem('warranty_subtype_id')

        let damageBody = {
          sinister_id: this.getSinisterId,
          event_id: this.stateWarrantySecondaryId,
          category: this.getWarrantyId,
          subcategory: subTypeId,
          form_info: report,
          images: this.imgList
        }

        const postBody = {
          lat: this.stateWarrantyCoordinates.lat,
          lon: this.stateWarrantyCoordinates.lng,
          zip_code: this.stateWarrantyZipCode,
          real_estate: this.getPropertyType,
          declarant: this.stateWarrantyResidentType,
          more_than_two_years: this.stateWarrantyMoreThanTwoYears
        }

        damageBody = {
          ...damageBody,
          ...postBody
        }
        this.formsDamages.push(damageBody)
      })
    },

    /**
     * Compares the img list and the report category  and if the title matches it will concats the images to the imgList
     */
    concatImageLists(
      reportCategoryTitle,
      imgListCategoryTitle,
      targetImg,
      imgListType
    ) {
      const imgListCategory = targetImg[imgListCategoryTitle]
      const categoryMatches =
        reportCategoryTitle.indexOf(imgListCategory) !== -1
      const imgListHasItems = targetImg[imgListType].length > 0

      if (imgListHasItems && categoryMatches) {
        targetImg[imgListType].forEach((img) => {
          delete img.imgSrc
        })
        this.imgList = this.imgList.concat(targetImg[imgListType])
      }
    },

    /**
     * Sets the imageListEnsemble and the imageListPres into one single list
     */
    setImageLists(keyDamagedPart, report) {
      const reportCategory = report[keyDamagedPart]

      this.imageCategoriesEnsemble.forEach((image) => {
        this.concatImageLists(
          reportCategory,
          'categoryTitleEnsemble',
          image,
          'imageListEnsemble'
        )
      })

      this.imageCategoriesPres.forEach((image) => {
        this.concatImageLists(
          reportCategory,
          'categoryTitlePres',
          image,
          'imageListPres'
        )
      })
    },

    checkImages() {
      if (!this.addDamagesHasImages || Object.keys(this.imgList)[0] === '0')
        return true

      const imageTypes = ['inputImgEnsemble', 'inputImgPres']
      const imageListTypes = [
        ...new Set(this.imgList.map((image) => image.imageType))
      ]

      return imageTypes.every(
        (imageType) => imageListTypes.indexOf(imageType) > -1
      )
    },

    /**
     * If there is inputsurfacedata, launches the validation for it, if there is no input errors it will check if there is a sinister id stored in the state otherwise it will get the info of this sinister id, afterwards for each report stored in the state array it will post the damage, it has to do it one by one because the damages can share reparations codes, so when reportqty is 0, meaining all the reports have been added it will go to the next route, if there is an error it will set the error and then go to the next route
     */
    handleSendDamages: async function () {
      this.loading = true
      if (this.inputSurfaceData) this.inputSurfaceValidation()
      this.validateAllTextNrInputs()

      if (
        !this.inputTextNumberError &&
        !this.inputTextNrFormError &&
        !this.inputTextDescriptionFormError
      ) {
        if (!this.getSinisterId) {
          const sinisterId = this.getSinisterId
          await this.actWarrantyGetSinisterWoLoader(sinisterId)
        }
        this.handleSetFormDamage().then(async () => {
          const imagesValidated = await this.checkImages()

          if (imagesValidated) {
            if (imagesValidated && this.formsDamages.length >= 1) {
              this.reportsQty = this.formsDamages.length

              this.formsDamages.forEach(async (form) => {
                await apiPatchDamage(form)
                  .then(() => {
                    this.reportsQty -= 1
                  })
                  .catch((err) => {
                    this.reportsQty -= 1
                    this.timer === 0 ? (this.timer = 800) : (this.timer += 200)
                    this.setError(err)
                    this.loading = false
                  })
                if (
                  this.inputTextNumberError === false &&
                  this.reportsQty === 0
                ) {
                  this.goToDamagesViewRoute()
                }
              })
            }
          } else {
            this.loading = false
            window.scrollTo(0, 0)
            this.throwNotification(
              this.$t('claim.details.errorImages'),
              this.$t('claim.details.errorImages'),
              'KO'
            )
            // Send sentry custom event
            const scope = new Sentry.Scope()
            scope.setTag('section', 'damageDetails handleSendDamages')
            scope.setContext({
              damagesDetails: imagesValidated
            })
            Sentry.captureException(
              new Error('Error on validated images in damageDetails.js'),
              () => scope
            )
          }
        })
      } else {
        this.loading = false
        window.scrollTo(0, 0)
        if (this.inputTextDescriptionFormError) {
          this.throwNotification(
            this.$t('claim.details.errorMsgGeneral'),
            this.$t('textDescriptionError'),
            'KO'
          )
        } else {
          this.throwNotification(
            this.$t('claim.details.errorMsgGeneral'),
            this.$t('claim.details.errorMsgGeneral'),
            'KO'
          )
        }
      }
    },

    /**
     * Sets the timer amount and the error in order to show the notification error with the literal of the form that has the error
     */
    setError(err) {
      const objectErrorDamage = JSON.parse(err.response.config.data)
      const literalDamageError = this.getLiteralDamageError(objectErrorDamage)
      const errs = [400, 500, 404]
      const errCode =
        errs.find((errCode) => err.response.status === errCode) || 404
      const messageNotification =
        this.$t(`notifications.error.${errCode}.title`) +
        ' ' +
        literalDamageError

      // Send sentry custom event
      const scope = new Sentry.Scope()
      scope.setTag('section', 'damageDetails setError')
      scope.setContext({
        damagesDetails: err
      })
      Sentry.captureException(new Error('Set error for errorCode'), () => scope)
      setTimeout(() => {
        this.throwNotification(messageNotification, messageNotification, 'KO')
      }, this.timer)
    },

    /**
     * Clears all the updated properties in this view, and pushes the params for the damages-view route
     */
    goToDamagesViewRoute() {
      const damagesViewViewName = 'damages-view'
      this.mutWarrantyClearForms()
      this.mutWarrantyClearReport()
      this.mutWarrantyClearReportByCategory()
      this.mutWarrantyClearReportMurs()
      this.mutWarrantyClearSelectedDamagedParts()
      this.goToView(damagesViewViewName)
    },

    /**
     * Based on the errorDamage it will return the literal of this report damage
     */
    getLiteralDamageError(damageError) {
      const reportErrorAssetDamage = JSON.stringify(
        damageError.form_info.asset_damages
      )
      const damageErrorForm = this.dataForms.find((form) => {
        const formAssetDamages = JSON.stringify(form.form.asset_damages)
        if (reportErrorAssetDamage === formAssetDamages) {
          return form
        }
      })
      const literalDamageError = damageErrorForm.damagedPart.literal
      return literalDamageError
    },

    routeToDamagesTypes() {
      const damageTypeViewName = 'damages-types'
      const damageId = 0
      const propertyType = this.getPropertyType
      this.goToView(damageTypeViewName, { damageId, propertyType })
    },

    /**
     * Validates all text nr inputs using the vuelidate
     */
    validateAllTextNrInputs() {
      this.$v.inputDescriptionData.$touch()
      const textNrForms = this.$refs.form.filter(
        (form) => form.$refs.textNumbers
      )

      const textNrInputs = textNrForms.map((form) => form.$refs.textNumbers)
      const textNrValidations = []

      textNrInputs.forEach((form) => {
        form.forEach((input) => textNrValidations.push(input))
      })

      textNrValidations.forEach((input) => {
        if (input.name != AUTRES_VALUE) {
          input.$v.$touch()
          if (input.$v.$invalid) {
            this.inputTextNrFormError = true
          } else {
            this.inputTextNrFormError = false
          }
        } else {
          if (this.$v.inputDescriptionData.$error) {
            this.inputTextDescriptionFormError = true
          } else {
            this.inputTextDescriptionFormError = false
          }
        }
      })
    },

    validatetextDescriptionInputs() {
      const textDescriptionForms = this.$refs.form.filter(
        (form) => form.$refs.textDescription
      )

      const textDescriptionInputs = textDescriptionForms.map(
        (form) => form.$refs.textDescription
      )
      const textDescriptionValidations = []

      textDescriptionInputs.forEach((form) => {
        form.forEach((input) => textDescriptionValidations.push(input))
      })

      textDescriptionValidations.forEach((input) => {
        if (input.name != AUTRES_VALUE) {
          input.$v.$touch()
          if (input.$v.$invalid) {
            this.inputTextDescriptionFormError = true
          } else {
            this.inputTextDescriptionFormError = false
          }
        }
      })
    },

    /**
     * Using the vulidate library, evaluates if there is an error in the inpus surface value and if so it will set the inputTextNumberError to true and scroll to the top of the page
     */
    inputSurfaceValidation() {
      this.$v.$touch()
      if (this.$v.inputSurfaceValue.$error) {
        maEventBus.$emit('inputTextNumbers:error')
        this.inputTextNumberError = true
        setTimeout(() => {
          this.inputTextNumberError = false
        }, 2000)
      }
    },
    /**
     * It is executed when the inputs of the form are being changed, it updates the report that coresponds with the form category
     */
    handleFormChange: function (event) {
      this.targetCategory =
        event.categoryTitle.indexOf('MUR') !== -1 ? 'MUR' : event.categoryTitle
      const category = this.targetCategory
      const key = event.inputId
      const value = this.getValue(event.inputVal)
      this.mutWarrantyUpdateReportByCategory({ category, key, value })

      if (!this.isUpdateFormRequired(key)) {
        let report = this.getReport(category)
        if (this.targetCategory === EXT) {
          this.mutWarrantyUpdateReportProperties({ key, value })
          this.mutWarrantyUpdateDamagedPartKey(this.getReportPropertyByValue(report, category))
        }

        this.updateFormManually(report)
      }
    },

    /**
     * If the value type is not and object and it finds a ',' in the value it replaces it by '.' otherwise it returns the value
     */
    getValue(value) {
      if (typeof value !== 'object' && value.indexOf(',') !== -1) {
        return value.replace(',', '.')
      } else {
        return value
      }
    },

    /**
     * Sets active input value and calls updateForm method
     */
    handleNestedComponents: debounce(function (dataActiveInput) {
      this.activeInputValue = dataActiveInput.inputVal
      if (dataActiveInput.inputId === AUTRES_GEN) {
        this.inputDescriptionData = dataActiveInput.inputVal
      }

      if (this.isUpdateFormRequired(dataActiveInput.inputId)) {
        this.updateForm(dataActiveInput)
      }
    }, 250),

    /**
     * Sets active input value and calls updateForm method
     */
    updateForm: function ({ inputId, inputVal }) {
      // gets the targetReport category
      const targetReportCategory = this.targetCategory.indexOf('MUR') !== -1 ? 'MUR' : this.targetCategory
      //this.mutWarrantyUpdateReport({ key: inputId, value: inputVal })
      const targetReport = this.getReport(targetReportCategory)
      this.loadForm(targetReport, this.getWarrantyId, targetReportCategory)
    },

    loadForm(report, warrantyId, targetReportCategory) {
      //this.mutWarrantyClearReportByCategory(targetReportCategory)
      const formInputs = document.querySelectorAll('.warranty__content input')
      formInputs.forEach(function (el) {
        el.disabled = true
      })

      apiGetForm(report, warrantyId)
      .then((data) => {
        this.mutWarrantyClearReportByCategory(targetReportCategory)
        this.$nextTick(() => {
          // update the form inputs of the matching targetCategory in dataForms
          this.dataForms.forEach((form) => {
            if (
              form.damagedPart.damagedPart
                .toUpperCase()
                .indexOf(targetReportCategory.toUpperCase()) !== -1
            ) {
              form.form = data.form
              this.addReportDefaultProperties(targetReportCategory)
              this.addSelectedValuesInput(data.form)
              this.getSurfaceInputData(data.form)
              this.removeUnecesaryCategories()
              return form
            }
          })

          // if Mur category - update value of murs
          if (targetReportCategory.indexOf('MUR') !== -1) {
            this.mutWarrantyUpdateReportMurs(this.stateWarrantyCounterMurs)
          }

          this.$nextTick(() => {
            // update the inputs focused/selected and refresh form
            this.handleUpdateForm()
          })
        })
        this.spinner = false
      })
      .finally(() => {
        this.formRegions = []
        formInputs.forEach(function (el) {
          el.disabled = false
        })
      })
    },

    /**
     * Sets the focus/blur for the active input
     */
    handleUpdateForm: function () {
      if (this.activeInput !== '') {
        const activeInputType = this.activeInput.getAttribute('type')
        const activeInputName = this.activeInput.getAttribute('name')
        const activeInputVal = this.activeInputValue
        // REFACTOR MOVER A FORM
        if (
          activeInputType === 'checkbox' &&
          this.activeInput.hasAttribute('isSelect')
        ) {
          document.querySelector('input[name=' + activeInputName + ']').focus()
          document.querySelector('input[name=' + activeInputName + ']').blur()
        } else if (activeInputType === 'text') {
          document.querySelector('input[name=' + activeInputName + ']').focus()
        } else {
          const el = document.querySelector(
            'input[value="' + activeInputVal + '"]'
          )
          if (el) el.focus()
        }
      }
    },

    /**
     * It's executed when the inputSurfaceValue is being changed, it updates the surface for each report
     */
    handleChangeInputSurface: function (valueSurface) {
      this.inputSurfaceValidation()
      if (!this.$v.$invalid) {
        let value = valueSurface.replace(',', '.')
        this.inputSurfaceValue = value
        this.addSurfaceInfoToReport()
      }
    },

    /**
     * Updated the dataForms property, adds the names for each category of the form, gets the input suface data and removes the unecessaryCategories
     */
    setFormsData: function () {
      this.dataForms = this.stateWarrantyForms
      this.addFormCategoryName()
      this.removeUnecesaryCategories()
    },

    updateFormManually(report) {
      const regions = this.dataForms[0].form.regions
      regions.forEach(region => {
        region.inputs.forEach(input => {
          if (this.avoidUpdateFormFields.includes(input.name) && !!report[input.name]) {
            input.selectedValue = report[input.name]
          }
        })
      })
    },

    isUpdateFormRequired(inputId) {
      return !this.avoidUpdateFormFields.includes(inputId)
    },

    getReport(targetReportCategory) {
      let targetReport = {}
      this.stateWarrantyReport.forEach((report) => {
        const key = Object.keys(report).find(p => !!p.includes(targetReportCategory))
        if (key === this.stateWarrantyLastSelctedKey || Object.keys(report).some(p => report[p] === targetReportCategory) || !targetReportCategory) {
          targetReport = report
        }
      })

      return targetReport
    },

    getReportPropertyByValue(report, value) {
      return Object.keys(report).find(p => report[p] === value)
    },

    /**
     * Loops to the surface inputs and if the input names match it will set the inputSurfaceData,
     * damageSurface properties
     */
    setSurfaceData(surfaceInputs) {
      surfaceInputs.forEach((input) => {
        if (input.name === 'ROOM_SURFACE') {
          this.inputSurfaceData = input
        }
        if (input.name === 'SURFACE_EVAL') {
          this.damageSurface = {
            key: input.name,
            value: input.selectedValue
          }
        }
      })
    },

    /**
     * It finds the region of the form that has the name surface and it has inputs, if it has,
     * it will push them to the formRegions array and if the formRegins has items, it will set the surfaceData
     * if it doesen't exist and add the surface info to the report
     */
    getSurfaceInputData(form) {
      const surfaceRegion = form.regions.find(
        (region) =>
          region.name.indexOf('SURFACE') !== -1 && region.inputs.length > 0
      )
      if (surfaceRegion) this.formRegions.push(surfaceRegion)

      if (this.formRegions.length > 0 && surfaceRegion) {
        if (!this.inputSurfaceData) {
          this.setSurfaceData(surfaceRegion.inputs)
        }
        this.addSurfaceInfoToReport()
      } else if (this.formRegions.length === 0 && !surfaceRegion) {
        this.inputSurfaceData = null
      } else if (this.formRegions.length > 0 && !surfaceRegion) {
      }
    },

    /**
     * If the form has the selectedvalue the same as the damage category selected in the previous view, it will add to the dataForms its category name
     */
    addFormCategoryName() {
      this.stateWarrantySelectedDamagedParts.forEach((damagedPart) => {
        if (!this.dataForms.damagedPart) {
          this.dataForms = this.dataForms.map((form) => {
            form.form.regions[0].inputs.forEach((input) => {
              if (input.selectedValue === damagedPart.damagedPart) {
                form = { ...form, damagedPart }
              }
              return input
            })
            return form
          })
        }
      })
    },

    /**
     * Removes the categories of the form that were previously selected also the surface inputs
     */
    removeUnecesaryCategories() {
      const damagedItemKey = this.getDamagedItemKey

      this.dataForms.forEach((form) => {
        form.form.regions[0].inputs = form.form.regions[0].inputs.filter(
          (input) => {
            return (
              input.name !== ASSETS &&
              input.name !== damagedItemKey &&
              input.type !== 'hidden'
            )
          }
        )

        if (this.damagedItemHasLevel2) {
          form.form.regions[0].inputs = form.form.regions[0].inputs.filter(
            (input) => {
              return input.name !== this.stateWarrantyDamagedPartKey
            }
          )
        }

        this.getSurfaceInputData(form.form)

        return form
      })
    },

    /**
     * It adds the default properties that were selected before for when the form is updated
     */
    addReportDefaultProperties(valueCategory) {
      const nameDamagedItem = this.getDamagedItemKey
      const nameDamagedPart = this.stateWarrantyDamagedPartKey
      let defaultProperties = {}
      defaultProperties['propertyType'] = this.getPropertyType
      defaultProperties[ASSETS] = this.getDamageType
      if (this.damagedItemHasLevel2) {
        defaultProperties[nameDamagedItem] = this.getDamagedItem
      }
      defaultProperties[nameDamagedPart] = valueCategory
      this.mutWarrantyAddReport(defaultProperties)
    },

    /**
     * Adds the asset damages for when the damage has to be added
     */
    addAssetDamages() {
      this.dataForms.forEach((form) => {
        const key = 'asset_damages'
        const value = form.form.asset_damages
        const category =
          form.damagedPart.damagedPart.indexOf('MUR') !== -1
            ? 'MUR'
            : form.damagedPart.damagedPart
        this.mutWarrantyUpdateReportByCategory({ category, key, value })
      })
    },

    /**
     * Adds the surfaceInfo to the report
     */
    addSurfaceInfoToReport() {
      let key = this.damageSurface ? this.damageSurface.key : null
      let value = this.damageSurface ? this.damageSurface.value : null
      this.mutWarrantyUpdateReportSurface({ key, value })
      key = this.inputSurfaceData ? this.inputSurfaceData.name : null
      value = this.inputSurfaceValue ? this.inputSurfaceValue : null
      this.mutWarrantyUpdateReportSurface({ key, value })
    },

    /**
     *Sets the focus when an input is modified
     */
    handleInputFocus: function () {
      const focusedInput = document.querySelector('input:focus')
      if (document.querySelector('input:focus') !== null) {
        this.activeInput = focusedInput
      }
    },

    /**
     * Updates the murs qty
     */
    updateQtyMurs() {
      const category = 'MUR'
      const key = 'QUANTITY'
      const value = this.stateWarrantyCounterMurs
      this.mutWarrantyUpdateReportByCategory({ category, key, value })
    },

    /**
     * Sets the selected values of the inputs in the report state object by matching its category
     */
    addSelectedValuesInput(form) {
      form.regions.forEach((region) => {
        region.inputs.forEach((input) => {
          if (input.selectedValue) {
            const key = input.name
            const value = input.selectedValue
            const category = this.targetCategory
            this.mutWarrantyUpdateReportByCategory({ category, key, value })
          }
        })
      })
    },

    /**
     * Sets the defauld values for each form - the input.selected values that come from the forms api
     */
    setSelectedValueInputs: function () {
      let category = ''
      this.dataForms.forEach((formCategory) => {
        if (
          formCategory.damagedPart &&
          formCategory.damagedPart.damagedPart.indexOf('MUR') !== -1
        ) {
          category = 'MUR'
          this.updateQtyMurs()
        } else {
          category = formCategory.damagedPart.damagedPart
        }

        formCategory.form.regions.forEach((region) => {
          region.inputs.forEach((input) => {
            if (input.selectedValue) {
              const key = input.name
              const value = input.selectedValue
              this.mutWarrantyUpdateReportByCategory({ category, key, value })
            }
          })
        })
      })
    },

    /**
     * Sets the image category names for the imageCategoriesEnsemble and imageCategoriesPres to be able to be filled with the photos for each category/form
     */
    setImageCategories() {
      this.stateWarrantySelectedDamagedParts.forEach((damagedPart) => {
        const categoryTitleEnsemble =
          damagedPart.damagedPart.indexOf('MUR') !== -1
            ? 'MUR'
            : damagedPart.damagedPart
        const imageListEnsemble = []
        this.imageCategoriesEnsemble.push({
          categoryTitleEnsemble,
          imageListEnsemble
        })

        const categoryTitlePres =
          damagedPart.damagedPart.indexOf('MUR') !== -1
            ? 'MUR'
            : damagedPart.damagedPart
        const imageListPres = []
        this.imageCategoriesPres.push({ categoryTitlePres, imageListPres })
      })
    },

    /**
     * When the file/photo is added, it checks the category and adds the filedata to the imageCategoriesEnsemble for that specific category/form
     */
    handleFileChangeEnsemble(event) {
      this.imageCategoriesEnsemble.forEach((imgCategory) => {
        if (
          event.categoryTitle.indexOf(imgCategory.categoryTitleEnsemble) !== -1
        ) {
          imgCategory.imageListEnsemble.push(event.fileData)
        }
      })
    },

    /**
     * When the file/photo is added, it checks the category and adds the filedata to the imageCategoriesPres for that specific category/form
     */
    handleFileChangePres(event) {
      this.imageCategoriesPres.forEach((imgCategory) => {
        if (event.categoryTitle.indexOf(imgCategory.categoryTitlePres) !== -1) {
          imgCategory.imageListPres.push(event.fileData)
        }
      })
    },

    /**
     * Returns the image list for the form category that it belongs to
     */
    imageCategoryEnsemble(category) {
      let list = []
      this.imageCategoriesEnsemble.forEach((image) => {
        if (category.indexOf(image.categoryTitleEnsemble) !== -1) {
          list = image.imageListEnsemble
        }
      })
      return list
    },

    /**
     * Returns the image list for the form category that it belongs to
     */
    imageCategoryPres(category) {
      let list = []
      this.imageCategoriesPres.forEach((image) => {
        if (category.indexOf(image.categoryTitlePres) !== -1) {
          list = image.imageListPres
        }
      })
      return list
    },

    /**
     * Set form and damage to initial values, empty objects. Then,
     *              it updates form.
     */
    clearForm: function () {
      this.damage = {}
      this.form = {}
      this.updateForm()
    },

    /**
     * If the damagedItem is level1 it means the form doesen't have a level 2 so it executes the routeToDamagesTypes otherwise goes back to previous page
     *
     */
    handleClickPrevRoute() {
      if (!this.damagedItemHasLevel2) {
        this.routeToDamagesTypes()
        this.mutWarrantyClearSelectedDamagedParts()
      } else {
        this.$router.go(-1)
      }
    },

    getCategoryProperty(report, valueToFind) {
      return Object.keys(report).find(p => report[p] === valueToFind)
    }
  },

  /**
   * When the counter of the murs changes, it updates the stateCounterMurs and adds the quantity that matches the murs to the coresponding form - report category
   */
  watch: {
    stateWarrantyCounterMurs(value) {
      this.mutWarrantyUpdateReportMurs(value)
    }
  },

  /**
   * Gets the form(s) data, when and input is focused it calls handleInputFocus
   */
  async mounted() {
    await this.getForm()
    // this.setWatchers()
    maEventBus.$on('inputWarranty:focus', ($event) =>
      this.handleInputFocus($event)
    )
  }
}
